import {collectLocalCheckpoints,collectLocalProgress,type ActivityDay,type ProgressRecord,type ProgressSkill} from './arabicProgressCore'

// Arabic Lab progress on the learner's account: client API, and the one-time import of what this browser saved
// before progress moved to the account. The browser's own stores are left in place.
const API='https://api.dawwin.al-ilm.net/arabic-progress'
const DEVICE='dawwin-arabic-progress-device-v1',IMPORTED='dawwin-arabic-progress-imported-v1',CHECKPOINTS_IMPORTED='dawwin-arabic-checkpoints-imported-v1'
export type ReviewInput={item_key:string;skill:ProgressSkill;rating:'good'|'hard'|'again';kind?:string;course_notebook_id?:string;label?:string;source?:string}

async function call<T>(path='',init:RequestInit={}){const r=await fetch(API+path,{...init,credentials:'include',headers:{Accept:'application/json','Content-Type':'application/json',...(init.headers||{})}});if(!r.ok)throw new Error((await r.json().catch(()=>null))?.error||('http_'+r.status));return await r.json() as T}
export const listArabicProgress=()=>call<{records:ProgressRecord[]}>()
export const recordArabicReview=(review:ReviewInput)=>call<{record:ProgressRecord}>('/review',{method:'POST',body:JSON.stringify(review)})
/** Saves one answer without holding up practice; a failed save is dropped (the browser's own record still has it). */
export const saveArabicReview=(review:ReviewInput)=>{void recordArabicReview(review).catch(()=>{})}
export const arabicActivity=(days=30)=>call<{days:ActivityDay[]}>(`/activity?days=${days}&tz=${new Date().getTimezoneOffset()}`)
export type AccountCheckpoint={course_notebook_id:string;section:string;best:number;last:number;total:number;attempts:number;taken_at:string|null}
export const listArabicCheckpoints=()=>call<{checkpoints:AccountCheckpoint[]}>('/checkpoints')
export const recordArabicCheckpoint=(c:{course_notebook_id:string;section:string;right:number;total:number})=>call<{checkpoint:AccountCheckpoint}>('/checkpoint',{method:'POST',body:JSON.stringify(c)})

function deviceId(){
 try{
  let id=localStorage.getItem(DEVICE)
  if(!id||!/^[A-Za-z0-9-]{8,80}$/.test(id)){id=crypto.randomUUID();localStorage.setItem(DEVICE,id)}
  return id
 }catch{return''}
}
let importing:Promise<void>|null=null
/**
 * Sends this browser's older progress to the account once. Safe to call on every visit: it does nothing once done,
 * and the server ignores a repeat from the same browser. A failure is retried on a later visit.
 */
export function ensureProgressImported(){
 return importing??=(async()=>{
  try{if(localStorage.getItem(IMPORTED))return}catch{return}
  const device=deviceId()
  if(!device)return
  const records=collectLocalProgress(k=>{try{return localStorage.getItem(k)}catch{return null}})
  try{
   await call('/import',{method:'POST',body:JSON.stringify({device_id:device,records:records.slice(0,5000)})})
   try{localStorage.setItem(IMPORTED,new Date().toISOString())}catch{/* storage may be unavailable */}
  }catch{importing=null}
 })()
}

let importingCheckpoints:Promise<void>|null=null
/** Sends the checkpoint results this browser kept to the account once (a repeat is harmless); they stay here too. */
export function ensureCheckpointsImported(){
 return importingCheckpoints??=(async()=>{
  try{if(localStorage.getItem(CHECKPOINTS_IMPORTED))return}catch{return}
  const records=collectLocalCheckpoints(k=>{try{return localStorage.getItem(k)}catch{return null}})
  try{
   if(records.length)await call('/checkpoints/import',{method:'POST',body:JSON.stringify({records:records.slice(0,500)})})
   try{localStorage.setItem(CHECKPOINTS_IMPORTED,new Date().toISOString())}catch{/* storage may be unavailable */}
  }catch{importingCheckpoints=null}
 })()
}
